var _a;
const location = window.location;
const host = location.host.split('.').slice(1).join('.');
export const serviceEnvironmentName = ((_a = document.querySelector('meta[name="service-environment"]')) !== null && _a !== void 0 ? _a : { content: 'whitelist' }).content;
export var StepByStepGlossary;
(function (StepByStepGlossary) {
    StepByStepGlossary["createApiKey"] = "create_api_key_binance";
    StepByStepGlossary["updateApiKey"] = "update_api_key_binance";
    StepByStepGlossary["deleteApiKey"] = "delete_api_key_binance";
    StepByStepGlossary["validateSession"] = "validateSession";
    StepByStepGlossary["confirmSession"] = "confirmSession";
    StepByStepGlossary["createWalletSecret"] = "create_wallet_secret";
    StepByStepGlossary["resetWalletSecret"] = "reset_wallet_secret";
    StepByStepGlossary["doTransfer"] = "create_withdraw";
    StepByStepGlossary["disconnectBuddy"] = "disconnect_buddy";
})(StepByStepGlossary || (StepByStepGlossary = {}));
const serviceEnvironments = {
    whitelist: {
        companyID: 'Whitelist ID',
        companyName: 'Whitelist',
        companyAbrv: 'WL',
        isAboutShown: true,
        isDiscordRequired: false
    },
    leagueoftraders: {
        companyID: 'League of Traders ID',
        companyName: 'League of Traders',
        companyAbrv: 'LoT',
        isAboutShown: false,
        isDiscordRequired: true
    },
    apex: {
        companyID: 'Apex ID',
        companyName: 'Apex',
        companyAbrv: 'Apex',
        isAboutShown: false,
        isDiscordRequired: false
    },
    lisa: {
        companyID: 'LiSA ID',
        companyName: 'LiSA',
        companyAbrv: 'LiSA',
        isAboutShown: false,
        isDiscordRequired: false
    }
};
export const isTrustedEnvironment = serviceEnvironmentName !== 'whitelist' && Object.keys(serviceEnvironments).includes(serviceEnvironmentName);
const domains = {
    passport: 'https://passport.' + host,
    traderProfile: 'https://trade.' + host,
    newBinance: 'https://trade.' + host + '/binance',
    screener: 'https://trade.' + host
};
export const getServiceConfigProperty = function (key) {
    const environment = isTrustedEnvironment ? serviceEnvironments[serviceEnvironmentName] : serviceEnvironments.whitelist;
    // @ts-ignore
    const res = environment[key];
    if (res !== undefined) {
        return res;
    }
    else {
        throw new Error(`Атрибут ${key} не является частью конфига`);
        return '';
    }
};
export default {
    BASE_URL: process.env.NODE_ENV === 'development' ? 'https://trade.local.host/api/v1' : domains.traderProfile + '/api/v1',
    TRADE_V2_API: process.env.NODE_ENV === 'development' ? 'https://trade.local.host/api/v2' : domains.traderProfile + '/api/v2',
    PASSPORT_API: process.env.NODE_ENV === 'development' ? 'https://passport.local.host/api/v1' : domains.passport + '/api/v1',
    PASSPORT: process.env.NODE_ENV === 'development' ? 'https://passport.local.host' : domains.passport,
    TRADE: process.env.NODE_ENV === 'development' ? 'https://trade.local.host' : domains.traderProfile,
    NEW_BINANCE: process.env.NODE_ENV === 'development' ? 'https://trade.local.host/binance' : domains.newBinance,
    PASSPORT_SAFETY: process.env.NODE_ENV === 'development' ? 'https://passport.local.host/id/' : domains.passport + '/id/',
    SCREENER: process.env.NODE_ENV === 'development' ? 'https://trade.local.host/api/screener/v1/' : domains.screener + '/api/screener/v1',
    BINANCE_PUBLIC: 'https://api1.binance.com',
    BINANCE_PUBLIC_FUTURES: 'https://fapi.binance.com',
    API_KEYS_RESET_TIMEOUT: 1000 * 60 * 10,
    WEBAUTH_CONNECTION_TIMEOUT: 2 * 60 * 1000,
    CODE_LENGTH: 6,
    SMS_OPERATIONS: {
        whitelists: {
            confirmCreateSecret: 'whitelist_create_secret',
            resetSecretSendEmail: 'whitelist_reset_email',
            resetSecretSendSMS: 'whitelist_reset_sms'
        },
        transfers: {
            withdrawRequest: 'withdraw_request'
        },
        apiKeys: {
            deleteApiKeySms: 'delete_api_key_sms',
            createApiKeySms: 'create_api_key_sms',
            updateApiKeySms: 'update_api_key_sms'
        }
    }
};
